import config from './config'
let baseUrl = config.JSONIP
import qs from 'qs'
// 配置API接口地址
let root = baseUrl
// 引用axios
let axios = require('axios')

import {v4 as uuidv4 } from 'uuid'


// axios.defaults.headers.post['Content-Type'] = '';


// 自定义判断元素类型JS
function toType(obj) {
	return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过虑函数
function filterNull(o) {
	for (let key in o) {
		if (o[key] === null) {
			delete o[key]
		}
		if (toType(o[key]) === 'string') {
			o[key] = o[key].trim()
		} else if (toType(o[key]) === 'object') {
			o[key] = filterNull(o[key])
		} else if (toType(o[key]) === 'array') {
			o[key] = filterNull(o[key])
		}
	}
	return o
}

/*
接口处理函数
这个函数每个项目都是不一样的，我现在调整的是适用于
https://cnodejs.org/api/v1 的接口，如果是其他接口
需要根据接口的参数进行调整。参考说明文档地址：
https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
主要是，不同的接口的成功标识和失败提示是不一致的。
另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(method, url, params, success, failure) {
	if (params) {
		params = filterNull(params)
	}
	axios({
			method: method,
			url: url,
			data: method === 'POST' || method === 'PUT' ? params : null,
			params: method === 'GET' || method === 'DELETE' ? params : null,
			baseURL: root,
			// withCredentials: true,
			withCredentials: false,
		})
		.then(function(res) {
			// console.log(res)
			// if (res.data.KKDTCOUNT != "0") {
			if (res.status == "200") {
				if (success) {
					success(res.data)
				}
			} else {
				if (failure) {
					failure(res.data)
				} else {
					console.log('error: ' + JSON.stringify(res.data))
				}
			}
		})
		.catch(function(err) {
			if (err) {
				console.log(err)
			}
		})
}




function uploadAxios(method, url, params, success, failure) {
	let config = {
	   headers: {'Content-Type': 'multipart/form-data'}
	}
	axios.defaults.baseURL = root;
	axios.post(
		url,
		params,
		{
			headers: {'content-type': 'multipart/form-data'}
		},
	).then((response) => {
		console.log(response)
		if (response.status == "200") {
			if (success) {
				success(response.data)
			}
		} else {
			if (failure) {
				failure(response.data)
			} else {
				console.log('error: ' + JSON.stringify(response.data))
			}
		}
	})
	.catch((error) => {
		
	})
}

// 返回在vue模板中的调用接口
export default {
	get: function(url, params, success, failure) {
		return apiAxios('GET', url, params, success, failure)
	},
	post: function(url, params, success, failure) {
		return apiAxios('POST', url, params, success, failure)
	},
	put: function(url, params, success, failure) {
		return apiAxios('PUT', url, params, success, failure)
	},
	delete: function(url, params, success, failure) {
		return apiAxios('DELETE', url, params, success, failure)
	},
	
	upload: function(url, params, success, failure) {
		return uploadAxios('POST', url, params, success, failure)
	},
	
	getBaseUrl: function() {
		return baseUrl
	},
	root
}
